import { Injectable, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  showSuccess(textOrTpl: string | TemplateRef<any>) {
    this.toasts.push({ textOrTpl, classname: 'bg-success text-light toast-success' });
  }

  showInfo(textOrTpl: string | TemplateRef<any>) {
    this.toasts.push({ textOrTpl, classname: 'bg-warning text-light toast-success loading-toast' });
  }

  showError(textOrTpl: string | TemplateRef<any>, delay: number = 3000) {
    if(this.toasts.length > 0 && this.toasts[this.toasts.length - 1].textOrTpl === textOrTpl) {
      this.toasts.pop();
    }
    this.toasts.push({ textOrTpl, classname: 'bg-danger text-light toast-error', delay: delay });
  }

  remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}